import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { Client } from '@df/core/service/client';
import { getElementWidth } from '@df/dom/fn/get-element-width';

@Component({
    selector: 'hot-spot',
    templateUrl: './hot-spot.html',
    styleUrls: ['./hot-spot.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class HotSpotComponent {
    @Input({
        required: true
    })
    positionX!: number;
    @Input({
        required: true
    })
    positionY!: number;

    @Input()
    title?: string;

    titleWidth = 0;

    @ViewChild('titleElement', { static: false })
    titleElement!: ElementRef;

    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        public elementRef: ElementRef,
        private client: Client
    ) {}

    protected checkTitleWidth(): void {
        if (!this.titleWidth || this.client.isCms) {
            this.titleWidth = getElementWidth(this.titleElement.nativeElement);
            this.changeDetectorRef.detectChanges();
        }
    }
}
